import type { Style } from 'ol/style';

export default class OlStyleCache {
  private cache: Record<string, Style> = {};

  fetch(key: string, onCacheMissFn: () => Style): Style {
    return this.getStyle(key) || (() => {
      const style = onCacheMissFn();
      this.setStyle(key, style);
      return style;
    })();
  }

  private getStyle(key: string): Style | null {
    return this.cache[key] || null;
  }

  private setStyle(key: string, style: Style): void {
    this.cache[key] = style;
  }

  clear(): void {
    this.cache = {};
  }
}
